import getProp from '@f/get-prop'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'
import {
  REQUEST_RULE,
  RECEIVE_RULE,
  REQUEST_RULE_ERROR,
  REQUEST_RULES_BY_PROJECT,
  RECEIVE_RULES_BY_PROJECT,
  REQUEST_RULES_BY_PROJECT_ERROR,
  UPDATE_RULE,
  UPDATE_RULE_VALUE,
  UPDATE_RULE_VALUE_ERROR,
  REQUEST_RULE_COUNTS,
  REQUEST_RULE_COUNTS_ERROR,
  RECEIVE_RULE_COUNTS
} from 'actions'

const initialState = {}

const countsReducer = createApiMiddlewareReducer({
  request: REQUEST_RULE_COUNTS,
  failure: REQUEST_RULE_COUNTS_ERROR,
  receive: RECEIVE_RULE_COUNTS
})

export default function (state = initialState, { type, payload = {}, error }) {
  const {
    workspaceSlug = '',
    projectSlug = '',
    ruleId = '',
    update = {}
  } = payload
  const workspace = getProp(workspaceSlug, state) || {}
  const project = getProp(workspaceSlug + '.' + projectSlug, state) || {}

  switch (type) {
    case REQUEST_RULES_BY_PROJECT:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            isRequesting: true
          }
        }
      }
    case RECEIVE_RULES_BY_PROJECT:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            isRequesting: false,
            data: payload.response.reduce((rules, rule) => {
              rules[rule.id] = {
                hasRequested: true,
                data: rule
              }
              return rules
            }, {})
          }
        }
      }
    case REQUEST_RULES_BY_PROJECT_ERROR:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            isRequesting: false,
            didRequestFail: true,
            error
          }
        }
      }
    case REQUEST_RULE:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            ...project,
            data: {
              ...project.data,
              [ruleId]: {
                isRequesting: true
              }
            }
          }
        }
      }
    case RECEIVE_RULE:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            ...project,
            data: {
              ...project.data,
              [ruleId]: {
                isRequesting: false,
                isSaving: false,
                hasRequested: true,
                data: payload.response
              }
            }
          }
        }
      }
    case REQUEST_RULE_ERROR:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            ...project,
            data: {
              ...project.data,
              [ruleId]: {
                isRequesting: false,
                didRequestFail: true,
                error
              }
            }
          }
        }
      }
    case UPDATE_RULE:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            ...project,
            data: {
              ...project.data,
              [ruleId]: {
                ...Object.assign({}, getProp(`data.${ruleId}`, project)),
                isSaving: true,
                data: {
                  ...getProp(`data.${ruleId}.data`, project),
                  ...update
                }
              }
            }
          }
        }
      }
    case UPDATE_RULE_VALUE:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            ...project,
            data: {
              ...project.data,
              [ruleId]: {
                ...Object.assign({}, getProp(`data.${ruleId}`, project)),
                isSaving: true,
                data: {
                  ...getProp(`data.${ruleId}.data`, project),
                  value: payload.value
                }
              }
            }
          }
        }
      }
    case UPDATE_RULE_VALUE_ERROR:
      return {
        ...state,
        [workspaceSlug]: {
          ...workspace,
          [projectSlug]: {
            ...project,
            data: {
              ...project.data,
              [ruleId]: {
                ...getProp(`${ruleId}`, project),
                isSaving: false,
                error
              }
            }
          }
        }
      }
    case REQUEST_RULE_COUNTS:
    case REQUEST_RULE_COUNTS_ERROR:
    case RECEIVE_RULE_COUNTS:
      const workspaceData = state[payload.workspaceSlug] || {}
      const sourceData = workspaceData[payload.sourceSlug] || { counts: {} }
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...workspaceData,
          [payload.sourceSlug]: {
            ...sourceData,
            counts: countsReducer(sourceData.counts, {type, payload})
          }
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/rules.js